import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { PORTFOLIO } from '@/constants/testIds';

const IMGS = [
    'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbGl2ZSUyMGV2ZW50JTIwY3Jvd2QlMjBjb25jZXJ0JTIwbHV4dXJ5fGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1563841930606-67e2bce48b78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwbGl2ZSUyMGV2ZW50JTIwY3Jvd2QlMjBjb25jZXJ0JTIwbHV4dXJ5fGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1596040078821-9b5f50e71ea5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBjb3Jwb3JhdGUlMjBldmVudCUyMHN0YWdlJTIwbGVkJTIwd2FsbCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1523525930602-e1239a31310b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBjb3Jwb3JhdGUlMjBldmVudCUyMHN0YWdlJTIwbGVkJTIwd2FsbCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbGl2ZSUyMGV2ZW50JTIwY3Jvd2QlMjBjb25jZXJ0JTIwbHV4dXJ5fGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwbGl2ZSUyMGV2ZW50JTIwY3Jvd2QlMjBjb25jZXJ0JTIwbHV4dXJ5fGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85',
];

const PROJECTS = [
    { id: 'p1', title: 'Annual Celebration', category: 'annual-days', img: IMGS[0] },
    { id: 'p2', title: 'Signature Product Launch', category: 'product-launches', img: IMGS[1] },
    { id: 'p3', title: 'Leadership Conference', category: 'conferences', img: IMGS[2] },
    { id: 'p4', title: 'Entertainment Spectacle', category: 'entertainment', img: IMGS[3] },
    { id: 'p5', title: 'Awards & Gala Night', category: 'corporate', img: IMGS[4] },
    { id: 'p6', title: 'Destination Retreat', category: 'destination', img: IMGS[5] },
    { id: 'p7', title: 'Corporate Convention', category: 'corporate', img: IMGS[2] },
    { id: 'p8', title: 'Keynote Reveal', category: 'product-launches', img: IMGS[0] },
    { id: 'p9', title: 'Annual Gala', category: 'annual-days', img: IMGS[3] },
];

const CATS = [
    { id: 'all', label: 'All Work' },
    { id: 'corporate', label: 'Corporate Events' },
    { id: 'annual-days', label: 'Annual Celebrations' },
    { id: 'product-launches', label: 'Product Launches' },
    { id: 'conferences', label: 'Conferences' },
    { id: 'entertainment', label: 'Entertainment Experiences' },
    { id: 'destination', label: 'Destination Events' },
];

export const Portfolio = () => {
    const [active, setActive] = useState('all');
    const filtered = active === 'all' ? PROJECTS : PROJECTS.filter(p => p.category === active);

    return (
        <>
            <section id="portfolio" data-testid={PORTFOLIO.root} className="relative py-24 sm:py-32 bg-neutral-950">
                <div className="container-lux">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14 items-end">
                        <div className="lg:col-span-7">
                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-8 h-px bg-gold" />
                                <span className="eyebrow">Portfolio</span>
                                <span className="text-white/30 text-[10px] tracking-[0.3em]">04</span>
                            </div>
                            <h2 className="font-display font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                                Experiences <span className="italic text-gold font-extralight">We&apos;ve Created.</span>
                            </h2>
                        </div>
                        <div className="lg:col-span-4 lg:col-start-9">
                            <p className="text-white/60 text-base leading-relaxed font-light">
                                A glimpse into the spectacles we&apos;ve crafted — each event a bespoke moment engineered to move audiences.
                            </p>
                        </div>
                    </div>

                    {/* Filters */}
                    <div className="flex flex-wrap gap-2 mb-12 border-t border-b border-white/10 py-4">
                        {CATS.map(c => (
                            <button
                                key={c.id}
                                data-testid={PORTFOLIO.filter(c.id)}
                                onClick={() => setActive(c.id)}
                                className={`px-4 py-2 text-[11px] tracking-[0.25em] uppercase transition-all ${
                                    active === c.id
                                        ? 'bg-gold text-black'
                                        : 'text-white/60 hover:text-gold'
                                }`}
                            >
                                {c.label}
                            </button>
                        ))}
                    </div>

                    {/* Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <AnimatePresence mode="popLayout">
                            {filtered.map((p, i) => (
                                <motion.a
                                    key={p.id}
                                    href="#contact"
                                    data-testid={PORTFOLIO.item(p.id)}
                                    layout
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.5, delay: i * 0.05 }}
                                    className="group relative block overflow-hidden bg-neutral-900 border border-white/5 hover:border-gold/40 transition-colors"
                                >
                                    <div className="aspect-[4/5] overflow-hidden">
                                        <img
                                            src={p.img}
                                            alt={p.title}
                                            className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                                            style={{ filter: 'brightness(0.75)' }}
                                        />
                                    </div>
                                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                                    <div className="absolute inset-0 p-6 flex flex-col justify-between">
                                        <div className="flex items-start justify-between">
                                            <span className="text-[10px] tracking-[0.3em] uppercase text-gold">{p.category.replace('-', ' ')}</span>
                                            <ArrowUpRight size={20} strokeWidth={1.4} className="text-white/80 group-hover:text-gold group-hover:rotate-45 transition-all" />
                                        </div>
                                        <div>
                                            <h4 className="font-display text-white text-xl font-medium leading-tight mb-1">{p.title}</h4>
                                            <div className="text-[10px] tracking-[0.2em] uppercase text-gold group-hover:text-white transition-colors">View Experience →</div>
                                        </div>
                                    </div>
                                </motion.a>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>
            </section>

            {/* Gallery section (mosaic) */}
            <section id="gallery" className="relative py-24 sm:py-32 bg-black">
                <div className="container-lux">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-8 h-px bg-gold" />
                        <span className="eyebrow">Gallery</span>
                        <span className="text-white/30 text-[10px] tracking-[0.3em]">05</span>
                    </div>
                    <h2 className="font-display font-light text-white text-4xl sm:text-5xl mb-14 tracking-tight">
                        Moments <span className="italic text-gold font-extralight">from the floor.</span>
                    </h2>

                    <div className="grid grid-cols-2 md:grid-cols-4 grid-rows-[repeat(6,120px)] md:grid-rows-[repeat(3,200px)] gap-3">
                        {[IMGS[2], IMGS[0], IMGS[3], IMGS[1], IMGS[4], IMGS[5], IMGS[0], IMGS[3]].map((src, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, scale: 0.96 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true, margin: '-40px' }}
                                transition={{ duration: 0.6, delay: i * 0.06 }}
                                className={`relative overflow-hidden bg-neutral-900 group ${
                                    i === 0 ? 'col-span-2 row-span-2' : i === 5 ? 'md:col-span-2' : ''
                                }`}
                            >
                                <img
                                    src={src}
                                    alt={`Event moment ${i + 1}`}
                                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                                    style={{ filter: 'brightness(0.8)' }}
                                />
                                <div className="absolute inset-0 border border-transparent group-hover:border-gold/40 transition-colors" />
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Portfolio;
